import * as React from 'react';
import BaggagePassenger from '../../BaggagePassenger/BaggagePassenger';
import { Props } from '../BaggageBody';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';

const AllFlight: React.FC<Props> = props => {
	const commonTheme = useTheme('UpgradeBaggageDialog').UpgradeBaggageDialog;

	return (
		<div className={cn(commonTheme.body, { [commonTheme.withTabs]: !!props.baggageTab })}>
			{props.passengers.map((passenger, i: number) => {
				const label = props.passengerLabels[passenger.id];
				const number = i + 1;

				return (
					<BaggagePassenger
						name={label}
						number={number}
						key={passenger.id}
						includedSegment={true}
						baggageByRfics={props.upgradeBaggages}
						mobileSelectedServiceId={props.mobileSelectedServiceId}
						passenger={passenger}
						align={props.valueAlign}
					/>
				);
			})}
		</div>
	);
};

export default AllFlight;
